import Vue from 'vue'
// Buefy
import Buefy from 'buefy'
// VeeValidate
import * as VeeValidate from 'vee-validate'
// Global Events
import GlobalEvents from 'vue-global-events'
import App from './App.vue'
import store from './store.js'
import router from './router'
import fullscreen from 'vue-fullscreen'
import 'buefy/dist/buefy.css'
import './assets/wakasoft.scss'
Vue.use(Buefy)
// Global Events
Vue.component(GlobalEvents)
// VeeValidate
Vue.use(VeeValidate)

// fullScreen
Vue.use(fullscreen)

// BootstrapVue
// Vue.use(BootstrapVue)
// Vue.use(IconsPlugin)
Vue.config.productionTip = false
// Vue.config.errorHandler = (err, vm, info) => {
//   console.log('ERREUR GLOBALE ' + err.message)
// }
new Vue({
  router: router,
  store: store,
  render: h => h(App)
}).$mount('#app')
